export default __webpack_public_path__ + "static/media/icon_founding_member_badge.4bd17054.png";